import {TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE} from '../shared/abstract-boxes';

export function ConditionsOnUserInputBoxViewConstuctor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;
  let companyId = context.companyId;
  let site = context.site;
  let scenarioId = context.scenarioId;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: false,
    angularTemplate: `
  <div layout="column">
    <div layout="column">
        <md-button ng-click="elementView.addCondition()"> 
          {{ 'parameters/quick_replies/details/graph/condition_on_user_input/add_condition' | translate }}
        </md-button>
    </div>
  </div>
`,
    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
    },


    addCondition: function () {
      services.QuickRepliesFactory.createUniqueId(companyId, site.id, scenarioId)
      .then(response => {
        let condition = this.createCondition(response.data.id);
        this.model.graph.addCell(condition);
        this.model.embed(condition);
        this.reorderChildren();
        this.resizeBox();
      },
        services.AlertingFactory.httpErrorHandler());
    },

    createCondition: function ( id,
                                position = TMP_ELEMENT_POSITION,
                                size = TMP_ELEMENT_SIZE,
                                elementData={'title': services.$translate.instant('parameters/quick_replies/details/graph/condition_on_user_input/new_default_condition')}) {
      return new joint.shapes.html.NewCondition({id, position, size, elementData});
    },

    isChildAlwaysFirst: function(child) {
      return child.get('type') === 'html.OtherUserInputText';
    },

     // useful for drag and drop, see AbstractBoxElementWithDragAndDropView.repositionOtherChildren
     paddingTop: function() {
      return this.heightOfHTMLContent();
    }
});
}
